import { render, staticRenderFns } from "./coberturasAmplia.vue?vue&type=template&id=6e3b6704"
import script from "./coberturasAmplia.vue?vue&type=script&lang=js"
export * from "./coberturasAmplia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports